import { render, staticRenderFns } from "./SharedCPDEditor.vue?vue&type=template&id=55f83722&scoped=true"
import script from "./SharedCPDEditor.vue?vue&type=script&lang=js"
export * from "./SharedCPDEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f83722",
  null
  
)

export default component.exports